export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string[];
  status: string;
  latestChapter: number;
  hotness: number;
  rating: number;
  description: string;
  totalChapters: number;
  updateTime: string;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '斗破苍穹',
    author: '天蚕土豆',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20epic%20fantasy%20male%20protagonist%20with%20flame%20power%20standing%20on%20cliff%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20red%20tones%2C%20martial%20arts%20theme%2C%20clean%20illustration%20style%20with%20dark%20background%2C%20professional%20anime%20art%2C%20sharp%20lines%2C%20vivid%20colors&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: ['热血', '奇幻', '武侠'],
    status: '连载中',
    latestChapter: 456,
    hotness: 9850000,
    rating: 4.9,
    description: '这里是属于斗气的世界，没有花哨艳丽的魔法，有的，仅仅是繁衍到巅峰的斗气！新书等级制度：斗者，斗师，大斗师，斗灵，斗王，斗皇，斗宗，斗尊，斗圣，斗帝。',
    totalChapters: 456,
    updateTime: '2026-07-07',
  },
  {
    id: 2,
    title: '一人之下',
    author: '米二',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20modern%20supernatural%20martial%20arts%20young%20man%20with%20mysterious%20power%20in%20urban%20setting%2C%20dynamic%20pose%2C%20cool%20color%20tone%20with%20green%20accents%2C%20clean%20anime%20illustration%20style%2C%20dark%20background%20with%20energy%20effects%2C%20professional%20comic%20art&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: ['热血', '悬疑', '都市'],
    status: '连载中',
    latestChapter: 612,
    hotness: 8720000,
    rating: 4.8,
    description: '随着父亲失踪，神秘少女冯宝宝的造访，少年张楚岚的平静校园生活被彻底颠覆。急于解开爷爷和自身秘密的张楚岚，和没有任何记忆的"不死少女"冯宝宝开启了一段惊心动魄的冒险之旅。',
    totalChapters: 612,
    updateTime: '2026-07-08',
  },
  {
    id: 3,
    title: '狐妖小红娘',
    author: '小新',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20romance%20fantasy%20beautiful%20fox%20spirit%20girl%20with%20long%20flowing%20hair%20in%20traditional%20red%20dress%2C%20cherry%20blossom%20petals%2C%20soft%20pink%20and%20warm%20tones%2C%20romantic%20atmosphere%2C%20clean%20anime%20illustration%20style%2C%20elegant%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: ['恋爱', '奇幻', '冒险'],
    status: '连载中',
    latestChapter: 389,
    hotness: 7650000,
    rating: 4.7,
    description: '根据古典小说记载，世上有人有妖，妖会与人相恋，妖寿命千万年，人的寿命有限，人死了，妖还活着。人会投胎转世，但投胎以后，不记得上辈子的爱。妖如果痴情的话，就去找狐妖"购买"一项服务，让投胎转世的人，回忆起前世的爱。',
    totalChapters: 389,
    updateTime: '2026-07-06',
  },
  {
    id: 4,
    title: '镇魂街',
    author: '许辰',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20action%20supernatural%20male%20warrior%20with%20ancient%20armor%20and%20spirit%20guardian%20behind%20him%2C%20dramatic%20battle%20scene%2C%20dark%20atmosphere%20with%20golden%20and%20crimson%20accents%2C%20powerful%20illustration%20style%2C%20clean%20comic%20art&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: ['热血', '奇幻', '冒险'],
    status: '连载中',
    latestChapter: 342,
    hotness: 6980000,
    rating: 4.6,
    description: '普通的应届大学毕业生夏铃在求职之际，收到了一条奇怪的面试通知，误入罗刹街并遭受到了恶灵的袭击，幸而被镇魂将曹焱兵搭救。然而，种种迹象表明夏铃的出现并非偶然，她的身世谜团也随之浮出水面。',
    totalChapters: 342,
    updateTime: '2026-07-05',
  },
  {
    id: 5,
    title: '大理寺日志',
    author: 'RC',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20historical%20comedy%20anthropomorphic%20white%20cat%20in%20traditional%20Chinese%20official%20robe%20in%20ancient%20Tang%20dynasty%20setting%2C%20humorous%20expression%2C%20warm%20sepia%20tones%2C%20clean%20illustration%20style%2C%20historical%20palace%20background&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: ['搞笑', '悬疑', '武侠'],
    status: '已完结',
    latestChapter: 198,
    hotness: 5430000,
    rating: 4.8,
    description: '以唐朝武则天时期为背景，讲述了在大理寺任职的众人，在白猫少卿李饼的带领下，展开各种惊心动魄的破案冒险故事。融合了历史、悬疑与搞笑元素。',
    totalChapters: 198,
    updateTime: '2026-06-28',
  },
  {
    id: 6,
    title: '星海镖师',
    author: '颜开',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20sci-fi%20action%20young%20bounty%20hunter%20with%20high-tech%20weapon%20in%20futuristic%20galactic%20setting%2C%20dynamic%20action%20pose%2C%20cool%20blue%20and%20silver%20tones%20with%20neon%20accents%2C%20clean%20anime%20illustration%20style&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: ['科幻', '热血', '冒险'],
    status: '连载中',
    latestChapter: 267,
    hotness: 4120000,
    rating: 4.5,
    description: '在未来世界中，人类已经进入星际时代。星海镖师是一个特殊的职业，他们穿梭于各个星球之间，接受各种委托任务。少年唐小镖在师父的引导下，踏上了成为最强镖师的冒险之路。',
    totalChapters: 267,
    updateTime: '2026-07-04',
  },
  {
    id: 7,
    title: '怦然心动',
    author: 'Kid岁',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20romance%20school%20life%20beautiful%20young%20couple%20under%20cherry%20blossom%20tree%20in%20school%20uniform%2C%20soft%20pastel%20pink%20and%20light%20blue%20tones%2C%20sweet%20atmosphere%2C%20clean%20shojo%20manga%20style%2C%20gentle%20lighting&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: ['恋爱', '都市'],
    status: '已完结',
    latestChapter: 156,
    hotness: 7890000,
    rating: 4.6,
    description: '因为一次偶然的相遇，狄淇儿和江应怜成为了同桌。两个人从最初的互不相识到慢慢了解彼此，经历了青春的酸甜苦辣，最终收获了一段纯真美好的校园恋情。',
    totalChapters: 156,
    updateTime: '2026-06-15',
  },
  {
    id: 8,
    title: '全职高手',
    author: '蝴蝶蓝',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20esports%20gaming%20skilled%20male%20player%20with%20game%20controller%20in%20virtual%20reality%20arena%2C%20dynamic%20competitive%20atmosphere%2C%20cool%20silver%20and%20gold%20tones%2C%20clean%20anime%20illustration%20style%2C%20professional%20art&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: ['热血', '科幻', '都市'],
    status: '连载中',
    latestChapter: 523,
    hotness: 6540000,
    rating: 4.7,
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部的驱逐，离开职业圈的他寄身于一家网吧成了一个小小的网管。但是，拥有十年游戏经验的他，在荣耀新开的第十区重新投入了游戏，带着对往昔的回忆和一把未完成的自制武器，开始了重返巅峰之路。',
    totalChapters: 523,
    updateTime: '2026-07-07',
  },
  {
    id: 9,
    title: '偷星九月天',
    author: '周洪滨/小松',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20action%20romance%20thief%20couple%20in%20steampunk%20setting%20with%20moon%20background%2C%20mysterious%20atmosphere%2C%20warm%20amber%20and%20deep%20purple%20tones%2C%20clean%20illustration%20style%2C%20dramatic%20composition&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: ['悬疑', '恋爱', '冒险'],
    status: '已完结',
    latestChapter: 320,
    hotness: 5870000,
    rating: 4.5,
    description: '少年侦探九月天因一次任务与神秘少女琉星相遇，两人卷入了一场关于古悉兰王国宝藏的惊天阴谋中。在追寻真相的过程中，友情、爱情、背叛交织，一场跨越千年的宿命之恋徐徐展开。',
    totalChapters: 320,
    updateTime: '2026-05-20',
  },
  {
    id: 10,
    title: '秦时明月',
    author: '温世仁/孙家裕',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20historical%20martial%20arts%20young%20swordsman%20in%20traditional%20Chinese%20hanfu%20with%20ancient%20sword%20in%20Qin%20dynasty%20setting%2C%20epic%20landscape%20background%2C%20golden%20and%20crimson%20tones%2C%20clean%20illustration%20style&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: ['武侠', '奇幻', '冒险'],
    status: '连载中',
    latestChapter: 234,
    hotness: 4760000,
    rating: 4.6,
    description: '故事背景取自秦始皇统一六国到西楚霸王项羽攻陷咸阳这段英雄辈出的历史时期，以少年荆天明的成长经历为主线，讲述了一段充满热血、冒险与成长的传奇故事。',
    totalChapters: 234,
    updateTime: '2026-07-03',
  },
  {
    id: 11,
    title: '非人哉',
    author: '一汪空气',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comedy%20slice%20of%20life%20mythological%20creatures%20as%20modern%20office%20workers%20in%20casual%20setting%2C%20colorful%20and%20humorous%2C%20bright%20warm%20tones%2C%20clean%20cartoon%20illustration%20style%2C%20fun%20atmosphere&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: ['搞笑', '都市'],
    status: '连载中',
    latestChapter: 678,
    hotness: 8340000,
    rating: 4.9,
    description: '传说中的神仙妖怪们来到现代人类社会，体验普通人的日常生活。九尾狐九月、龙女敖烈、哪吒等神话人物在现代都市中发生的各种搞笑日常故事。',
    totalChapters: 678,
    updateTime: '2026-07-08',
  },
  {
    id: 12,
    title: '镖人',
    author: '许先哲',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20historical%20action%20lone%20swordsman%20escort%20in%20desert%20landscape%20with%20horse%2C%20gritty%20realistic%20ink%20wash%20painting%20style%2C%20warm%20sepia%20and%20dark%20tones%2C%20powerful%20composition%2C%20professional%20comic%20art&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: ['武侠', '热血', '冒险'],
    status: '连载中',
    latestChapter: 178,
    hotness: 9210000,
    rating: 4.9,
    description: '大业三年，隋王朝在隋炀帝杨广的残暴统治下民不聊生。身手不凡的镖客刀马行走于西域大漠，在护送神秘任务中卷入了改变天下格局的巨大风波。一部重现隋唐江湖的热血漫画。',
    totalChapters: 178,
    updateTime: '2026-07-06',
  },
];

export const getComicsByCategory = (slug: string): Comic[] => {
  if (slug === 'all') return comics;
  const category = categories.find((c) => c.slug === slug);
  if (!category) return [];
  return comics.filter((comic) => comic.category.includes(category.name));
};

export const getHotComics = (limit: number = 6): Comic[] => {
  return [...comics].sort((a, b) => b.hotness - a.hotness).slice(0, limit);
};

export const getNewComics = (limit: number = 6): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()).slice(0, limit);
};

export const getComicById = (id: number): Comic | undefined => {
  return comics.find((comic) => comic.id === id);
};

import { categories } from './categories';